import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import { ResponsiveImage } from '@web/molecules/ResponsiveImage';
import { MuxVideo } from '@web/components/MuxVideo';
import {
  MediaCellWrapper,
  MediaCellMobile,
  MediaCellDesktop,
} from './styles.js';

export const MediaCell = ({
  mobileAsset,
  desktopAsset,
  roundedAsset = false,
}) => {
  return (
    <MediaCellWrapper $rounded={roundedAsset}>
      <MediaCellMobile>
        {mobileAsset?.component === 'mux_video' ? (
          <MuxVideo {...mobileAsset} />
        ) : (
          <ResponsiveImage
            {...mobileAsset}
            style={{ width: '100%', height: 'auto' }}
          />
        )}
      </MediaCellMobile>
      <MediaCellDesktop>
        {desktopAsset?.component === 'mux_video' ? (
          <MuxVideo {...desktopAsset} />
        ) : (
          <ResponsiveImage
            {...desktopAsset}
            {...omit(desktopAsset, ['width', 'height'])}
          />
        )}
      </MediaCellDesktop>
    </MediaCellWrapper>
  );
};

MediaCell.displayName = 'MediaCell';

MediaCell.propTypes = {
  mobileAsset: PropTypes.object.isRequired,
  desktopAsset: PropTypes.object.isRequired,
  roundedAsset: PropTypes.bool,
};
